<i18n>
{
	"en": {
		"edipartSetupHeader" : "Setup",
		"sender": "Sender",
		"name": "EDI Part name",
		"receiver": "Receiver",
		"description": "Description",
		"inboundSetups": "Inbound EDI Configurations",
		"outboundSetups": "Outbound EDI Configurations",
		"save": "Save EDI part",
		"noEdiPartSelected": "Select an EDI part to see the configuration."
	},

	"no": {
		"edipartSetupHeader" : "Oppsett",
		"sender": "Sender",
		"name": "EDI Part navn",
		"receiver": "Mottaker",
		"description": "Beskrivelse",
		"inboundSetups": "Inngående EDI oppsett",
		"outboundSetups": "Utgående EDI oppsett",
		"save": "Lagre EDI part",
		"noEdiPartSelected": "Velg en EDI-part for å se oppsett"
	}
}
</i18n>
<template>
	<t-vertical-panel class="edit-edipart-list">
		<div slot="header" class="edit-edipart-list-header">
			<t-panel-header size="md" type="bp" icon="cog">
				{{$t('edipartSetupHeader')}}
			</t-panel-header>
		</div>
		<div v-if="edipart.id" class="edi-part-content">
			<t-form-group class="edi-part-info">
				<t-text-input v-model="edipart.name"  :label="$t('name')"/>
				<t-text-area :label="$t('description')"/>
			</t-form-group>




			<t-tab-view
				:tabs="tabs"
				margin-bottom="8px"
			/>
		</div>
		<t-no-content-panel
			v-else
			icon="cog"
			iconType="bp"
			:text="$t('noEdiPartSelected')"
		/>
	</t-vertical-panel>
</template>

<script>

import { mapGetters } from './store/details/ediSetupDetails.store';
import InboundSettings from './InboundSettings';
import OutboundSettings from './OutboundSettings';
export default {
	computed: {
		...mapGetters(['edipart']),
		tabs() {
			return [
				{ component: InboundSettings, label: this.$t('inboundSetups') },
				{ component: OutboundSettings, label: this.$t('outboundSetups') },
			];
		},
	},
};
</script>
<style lang="scss" scoped>
.edit-edipart-list{
	border-left: 6px double rgba(193,163,181,0.1);
	border-right: 6px double rgba(193,163,181,0.1);
	.edit-edipart-list-header{
		display:flex;
		align-items: center;
		height: 95%;
		padding-left:1em;
	}
}

.edi-part-content{
	min-height:100%;
	display: grid;
	background: white;
	padding: 20px;
	box-sizing: border-box;
	grid-template-rows: min-content auto;
	row-gap: 20px;
}

.edi-part-info{
	display:grid;
	grid-template-columns: 260px;
	grid-template-rows: auto;
}

.edi-part-buttons{
	padding-top:2em;
}



</style>